<template>
  <div>
    <v-btn color="primary" class="mt-3 mb-2 mb-sm-4 ml-n4 text-capitalize light--text" @click="showDialog">
      <v-icon class="dark--text">mdi-call-split</v-icon>
      Transfer Plan
    </v-btn>
    <v-dialog v-model="show_dialog_box1" max-width="900px">
      <v-card class="pa-3 pop_bg">
        <v-card-title class="justify-center">
          <span class="dark--text text-h6"> Plan Transfer </span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="show_dialog_box1 = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <SearchCustomer @selectCustomer="selectCustomer" />
        <div v-if="customer">
          <span> <strong> To Customer Details </strong></span>
          <v-spacer></v-spacer>
          <span>
            Customer Name:<strong>
              {{ capitalizeFirstLetter(customer.user.firstnameEn) }}
              {{ capitalizeFirstLetter(customer.user.lastnameEn) }}
            </strong>
          </span>
          <span>
            Phone:
            <strong> {{ customer.user.phone }} </strong>
          </span>
          <!-- {{ auditList }} -->

          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row class="mt-4">
                <v-col cols="12" md="10" class="mx-auto">
                  <v-row justify="center">
                    <vc-date-picker :key="number" :min-date="minDate" :max-date="maxDate" v-model="planTransferDate" :disabled-dates="disabledDates" />
                  </v-row>
                  <v-row justify="end" class="mt-6">
                    <v-form ref="form" v-model="valid">
                      <v-btn :width="$vuetify.breakpoint.smAndUp ? 120 : ''" class="me-3 text-capitalize" color="primary" @click="saveDate()" :disabled="!valid" :loading="btnloading">
                        <v-icon left>mdi-plus</v-icon>
                        Transfer
                      </v-btn>
                    </v-form>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top :color="snackColor">{{ text }}</v-snackbar>
  </div>
</template>
<script>
import moment from "moment";
import SearchCustomer from "../SearchCustomer.vue";
import { Utils } from "../../../utils/utils";
export default {
  components: { SearchCustomer },
  created() {
    this.getCustomerFreezeDays();
    this.setUnavailableDates();
  },
  props: {
    subscribedPackage: {
      require: true,
    },
  },
  methods: {
    getCustomerFreezeDays() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("@/customer/components/freeze/api/getCustomerFreezeDays.graphql"),
          variables: {
            customer: this.$route.query.customerId,
          },
        })
        .refetch({
          customer: this.$route.query.customerId,
        })
        .then(data => {
          this.loading = false;
          if (data.data.getCustomerFreezeDays) {
            this.freezeDays = data.data.getCustomerFreezeDays;
          }
          if (this.freezeDays.find(x => x.isActive)) {
            this.hasActiveFreeze = true;
          }
          this.setUnavailableDates();
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    isPackageNotAvailableOnThisDay(date, availabelWeekDaysInNumbers) {
      let day = date.day();
      let available = availabelWeekDaysInNumbers.filter(x => x == day);
      return available.length > 0 ? false : true;
    },
    setUnavailableDates() {
      let fromDate = new Date(parseInt(this.subscribedPackage.start_date));
      let toDate = new Date(parseInt(this.subscribedPackage.end_date));
      let momentFromDate = moment(fromDate)
        .add(3, "h")
        .startOf("day");
      let momentToDate = moment(toDate)
        .add(3, "h")
        .endOf("day");
      var dateArray = new Array();
      let availableWeekDays = this.subscribedPackage.package.availableChoices[0].availableDays;
      let availabelWeekDays = Utils.getAvailabelWeekDaysInNumbers(availableWeekDays);

      while (momentFromDate <= momentToDate) {
        if (this.isPackageNotAvailableOnThisDay(momentFromDate, availabelWeekDays)) {
          dateArray.push(momentFromDate.toDate());
        }
        momentFromDate.add(1, "days");
      }

      if (this.freezeDays.length > 0) {
        this.freezeDays.forEach(freeze => {
          for (var m = moment(new Date(parseInt(freeze.fromDate))); m.isBefore(moment(new Date(parseInt(freeze.endDate)))); m.add(1, "days")) {
            console.log(m.format("YYYY-MM-DD"));
            dateArray.push(m.toDate());
          }
        });
      }

      this.disabledDates = [];

      dateArray.forEach(element => {
        let paused = {
          start: new Date(
            moment(element)
              .add(3, "h")
              .toDate()
          ),
          end: new Date(
            moment(element)
              .add(3, "h")
              .toDate()
          ),
        };
        this.disabledDates.push(paused);
      });
    },
    selectCustomer(customer) {
      this.customer = customer;
    },
    saveDate() {
      this.btnloading = true;
      debugger;
      if (!this.planTransferDate) {
        this.text = "Please select plan transfer date.";
        this.snackColor = "error";
        this.snackbar = true;
        this.btnloading = false;
        return false;
      }
      if (!this.customer._id) {
        this.text = "Please reselect cutomer.";
        this.snackColor = "error";
        this.snackbar = true;
        this.btnloading = false;
        return false;
      }
      this.$apollo
        .mutate({
          mutation: require("../salesOrder/api/transferSubscription.graphql"),
          variables: {
            input: {
              subscription: this.subscribedPackage._id,
              startDate: this.planTransferDate,
              customer: this.customer._id,
            },
          },
        })
        .then(() => {
          this.show_dialog_box1 = false;
          this.btnloading = false;
          this.snackbar = true;
          this.text = "Plan successfully transferred";
          this.snackColor = "success";
          this.$root.$emit("updateGetCustomerById");
        })
        .catch(error => {
          // Error
          this.text = error.message;
          this.snackColor = "error";
          this.snackbar = true;
          this.btnloading = false;

          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
        });
    },

    showDialog() {
      this.show_dialog_box1 = true;
    },
  },

  apollo: {
    getMealSelectionDate() {
      return {
        query: require("./api/getMealSelectionDate.graphql"),
        result({ data, loading }) {
          debugger;
          this.loading = loading;
          let date = data.getMealSelectionDate.packageSelectionDate;
          this.packageSelectionDate = moment(new Date(parseInt(date)));
          if (this.packageSelectionDate.isAfter(this.minDate)) {
            this.minDate = this.packageSelectionDate.format("YYYY-MM-DD");
          }
        },
      };
    },
  },

  data() {
    return {
      valid: false,
      show_dialog_box1: false,
      freezeDays: [],
      number: 0,
      planTransferDate: null,
      btnloading: false,
      loading: true,
      packageSelectionDate: null,
      totalItems: 25,
      disabledDates: [],
      minDate: moment(new Date(parseInt(this.subscribedPackage.start_date)))
        .add(3, "h")
        .toDate(),
      maxDate: moment(new Date(parseInt(this.subscribedPackage.end_date)))
        .add(3, "h")
        .toDate(),
      customer: null,
      text: "",
      options: {
        itemsPerPage: 25,
        page: 1,
      },
      snackbar: false,
      snackColor: "",
      test: "",
    };
  },
};
</script>
